import { tokenRequsetProcess, tokenResponseProcess, requsetProcess, responseProcess } from './processing.js'


export function request(config) {
    // if (config.headers.isToken !== true) config.data = requsetProcess(config.data);
    // if (config.headers.isToken == true) config.data = tokenRequsetProcess(config.data);
    return config
}
export function response(response) {
    // if (response.config.headers.isToken !== true) { 
    //     response.data = responseProcess(response.data);
    // }
    // if (response.config.headers.isToken == true) {
    //     response.data.result.data = tokenResponseProcess(response.data.result.data);
    // }
    return response;
}